module.exports = __webpack_public_path__ + "static/media/eye_close.0c633bbd.svg";